module.exports = __webpack_public_path__ + "static/img/user_type_user@3x.0cd6c8c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/user_type_user@3x.png
// module id = B5OR
// module chunks = 1